import React, { FC } from "react"
import { Modal } from "antd"
import { useStore } from "stores/utils/use-store"

export const GrantBattlePass: FC<{
  visible: boolean;
  onClose: () => void;
  onSuccess?: () => void;
}> = ({ visible, onClose, onSuccess }) => {
  const { dataStore: { accountDetailsStore } } = useStore()

  return (
    <Modal
      visible={visible}
      title="Grant Buff Pass?"
      onCancel={() => onClose()}
      onOk={async() => {
        accountDetailsStore.funcAfterSuccess = async() => {
          onClose()
          accountDetailsStore.resetFuncAfterSuccess()
          if (onSuccess) {
            onSuccess()
          }
        }
        await accountDetailsStore.grantBattlePass()
      }}
      okText="Grant"
      cancelText="Cancel"
      confirmLoading={accountDetailsStore.isLoading}
    >
      Do you really want to grant Buff Pass for this user?
    </Modal>
  )
}

